import React, { createContext, useContext, useState } from 'react';
import UserJourneyTracker from 'lib/user_journey/user_journey_tracker';

/**
 * @typedef {Object} UserJourneyContext
 * @property {UserJourneyTracker} userJourneyTracker
 * @property {function(UserJourneyTracker): void} setUserJourneyTracker
 */

/** @type {React.Context<UserJourneyContext>} */
const UserJourneysContext = createContext({
  userJourneyTracker: null,
  setUserJourneyTracker: null,
});

/**
 * Custom hook to extract user journey details
 *
 * Usage:
 *   const userJourney = useUserJourneys();
 *   userJourneyTracker = userJourney.userJourneyTracker;
 * @returns {UserJourneyContext}
 */
const useUserJourneys = () => useContext(UserJourneysContext);

const UserJourneysProvider = ({ children }) => {
  const [userJourneyTracker, setUserJourneyTracker] = useState(
    new UserJourneyTracker(),
  );

  return (
    <UserJourneysContext.Provider
      value={{ userJourneyTracker, setUserJourneyTracker }}
    >
      {children}
    </UserJourneysContext.Provider>
  );
};

export { UserJourneysProvider, useUserJourneys };
